module.exports = __webpack_public_path__ + "static/img/yj1.454c2a68.png";